import { camelToStartCase } from "@repo/helpers";

import { Button } from "../../basic/button";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger } from "../../basic/dropdown";
import { Column } from "../models";
import style from "./styles.module.scss";
import { Props } from "./types";

export default function ToggleColumnsDropdown<T>(props: Props<T>) {
	const { columns, updateVisibility } = props;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button>Show/Hide Columns</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className={style.dropdownContainer}>{columns.map(ColumnItem)}</DropdownMenuContent>
		</DropdownMenu>
	);

	function ColumnItem<T>(column: Column<T>) {
		const columnName = column.name || camelToStartCase(column.displayFunction?.name);
		return (
			<DropdownMenuCheckboxItem
				key={columnName}
				checked={column.visible}
				onCheckedChange={(checked) => updateVisibility(column.id, !!checked)}
				onSelect={(e) => e.preventDefault()}
			>
				{columnName}
			</DropdownMenuCheckboxItem>
		);
	}
}
